import React from "react";
import {connect} from "react-redux";
import {Button, Form, Input, message, Modal} from "antd";
import {displayErrors} from "../../libs/utils";
import {updateContentWriterSettings} from "../../actions/content_writer";

class WriterSettingsModal extends React.Component {
    state = {
        loading: false,
        openai_key: '',
        serpapi_key: '',
    };


    closeModal() {
        this.setState({
            loading: false,
            openai_key: '',
            serpapi_key: '',
        }, () => {
            this.props.close();
        });
    }

    saveSettings(field) {
        let data = {
            [field]: this.state[field].trim(),
        }

        this.setState({ loading: true });

        this.props.updateContentWriterSettings(data, () => {
            this.setState({ [field]: '' });
            message.success('Content writer settings saved successfully!');
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loading: false });
                displayErrors(err.response.data);
            }
        });
    }

    render() {
        return <Modal
            centered
            title='Writer Settings'
            open={this.props.showModal}
            destroyOnClose={true}
            footer={false}
            onCancel={() => this.closeModal()}>

            <Form layout='vertical'>
                <Form.Item label='Open AI key:' help={<small><em>(Required)</em></small>}>
                    <Input.Group compact>
                        <Input value={this.state.openai_key} style={{ width: 'calc(100% - 60px)', }}  onChange={(e) => this.setState({ openai_key: e.target.value })}/>
                        <Button type="primary" onClick={() => this.saveSettings('openai_key')}>Save</Button>
                    </Input.Group>
                </Form.Item>
                <Form.Item label='Open AI model:' help={<small><em>The model that will be used for content generation.</em></small>}>
                    <Input value='gpt-4o-mini' disabled />
                </Form.Item>
                <Form.Item label='SERP API key:' help={<small><em>(Optional)</em></small>}>
                    <Input.Group compact>
                        <Input value={this.state.serpapi_key} style={{ width: 'calc(100% - 60px)', }}  onChange={(e) => this.setState({ serpapi_key: e.target.value })}/>
                        <Button type="primary" onClick={() => this.saveSettings('serpapi_key')}>Save</Button>
                    </Input.Group>
                </Form.Item>
            </Form>
        </Modal>;
    }
}

export default connect(null, { updateContentWriterSettings })(WriterSettingsModal);